function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["description"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import { Carousel } from '@applyboard/crystal-ui';
import { SectionSpacer } from '@applyboard/ui-components';
import { ScholarshipsTitle } from "./ScholarshipsTitle";
import { ScholarshipCard } from '@applyboard/ab-scholarship';
var CARDS_PER_SLIDE = 2;
var removeDescription = function removeDescription(scholarship) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _ = scholarship.description,
    rest = _objectWithoutProperties(scholarship, _excluded);
  return rest;
};
export var Scholarships = function Scholarships(_ref) {
  var scholarships = _ref.scholarships;
  var scholarshipsCount = scholarships.length;
  var baseEventTrackingData = useMemo(function () {
    return {
      totalSlides: Math.ceil(scholarshipsCount / CARDS_PER_SLIDE),
      cardsPerSlide: CARDS_PER_SLIDE,
      totalScholarships: scholarshipsCount,
      scholarships: scholarships.map(removeDescription)
    };
  }, [scholarships, scholarshipsCount]);
  return /*#__PURE__*/React.createElement(SectionSpacer, null, /*#__PURE__*/React.createElement(ScholarshipsTitle, null), /*#__PURE__*/React.createElement(Carousel, {
    "aria-label": "Scholarships",
    itemGap: 16,
    itemsPerSlide: 2
  }, scholarships.map(function (scholarship, index) {
    return /*#__PURE__*/React.createElement(ScholarshipCard, {
      key: scholarship.id,
      scholarship: scholarship,
      eventTrackingOptions: {
        eventsPrefix: 'Programs Page - ',
        eventTrackingData: _objectSpread({
          cardScholarship: removeDescription(scholarship),
          cardIndexInSlider: index + 1,
          currentSlide: Math.ceil((index + 1) / CARDS_PER_SLIDE)
        }, baseEventTrackingData)
      }
    });
  })));
};